import { loadSession } from "../auth";
import { isPlatformAdmin } from "../utils/tenant";

// Helper utilities for gating normal feature loads while onboarding is
// incomplete. This keeps the frontend from calling normal app endpoints
// (assignments/my, trainings, dashboard stats, documents, etc.) while
// the user has blocking onboarding tasks.

export function _normalizeSessOnboarding(sess) {
  const raw = sess?.onboarding;
  return raw?.onboarding ?? raw ?? null;
}

export function getCachedOnboarding() {
  try {
    const sess = loadSession();
    return _normalizeSessOnboarding(sess);
  } catch {
    return null;
  }
}

export function hasOnboardingWork(onb) {
  if (!onb) return false;
  if (onb.is_complete === false) return true;
  if (Number(onb.blocking_tasks_count || 0) > 0) return true;
  if (Array.isArray(onb.tasks)) {
    return onb.tasks.some((t) => {
      const s = (t?.status || "").toString().toLowerCase();
      return s === "pending" || s === "in_progress" || s === "expired";
    });
  }
  return false;
}

export function shouldBlockFeatureLoads() {
  const sess = loadSession();
  const user = sess?.user;
  const isPlat = isPlatformAdmin(user);
  // Platform admins are never blocked
  if (isPlat) return false;

  const onb = _normalizeSessOnboarding(sess);
  // If onboarding is not yet known we conservatively block feature loads until
  // the route guard fetches it and navigates the user.
  if (!onb) return true;

  // If the user has work, block normal features (they must do onboarding)
  if (hasOnboardingWork(onb)) return true;

  // Otherwise allow feature loads
  return false;
}

const onboardingGate = { getCachedOnboarding, hasOnboardingWork, shouldBlockFeatureLoads };
export default onboardingGate;
